import * as React from "react";

export default function ErrorNotFound() {
  return (
    <h1>Page not found (404)</h1>
  )
}
